export default "__VITE_ASSET__CNX0vdqj__"